module.exports = __webpack_public_path__ + "media/images/user-46cd8f25ead0be89976adde620819bf6.png";